import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from "@mui/material";
import { currency } from "../../utils/formatters";

const getRiskColor = (days) => {
  if (days <= 15) return "#E24B4A"; // high danger
  if (days <= 30) return "#BA7517"; // warning
  return "#639922"; // safe-ish
};

export default function LikelyDeadSoonSection({ data }) {
  if (!data || !data.items?.length) return null;

  return (
    <Box
      id="likely-dead-section"
      sx={{
        mb: 3,
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: "3px",
              height: "18px",
              borderRadius: "2px",
              bgcolor: "#BA7517",
            }}
          />
          <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
            Likely dead soon
          </Typography>
        </Box>

        <Typography sx={{ fontSize: "12px", color: "text.secondary" }}>
          {data.sku_count} SKUs · {currency(data.at_risk_cash)} at risk
        </Typography>
      </Box>

      {/* Table */}
      <Box
        sx={{
          border: "1px solid rgba(186,117,23,0.25)",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        <Table size="small">
          <TableHead>
            <TableRow
              sx={{
                bgcolor: "rgba(186,117,23,0.08)",
              }}
            >
              <TableCell>Product</TableCell>
              <TableCell>Stock</TableCell>
              <TableCell>30d Sales</TableCell>
              <TableCell>Cover</TableCell>
              <TableCell>Last Sale</TableCell>
              <TableCell>Risk</TableCell>
              <TableCell>Cash</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data.items.map((item) => {
              const riskColor = getRiskColor(item.predicted_dead_in_days);

              return (
                <TableRow key={item.sku_code} hover>
                  {/* Product */}
                  <TableCell>
                    <Typography sx={{ fontSize: "13px", fontWeight: 500 }}>
                      {item.product_name}
                    </Typography>
                    <Typography sx={{ fontSize: "11px", color: "text.secondary" }}>
                      {item.sku_code} · {item.brand}
                    </Typography>
                  </TableCell>

                  {/* Stock */}
                  <TableCell>{item.inventory_units} u</TableCell>

                  {/* Sales */}
                  <TableCell sx={{ color: "#639922", fontWeight: 500 }}>
                    {item.units_sold_30d} u
                  </TableCell>

                  {/* Cover */}
                  <TableCell>{Math.round(item.stock_cover_days_30d)}d</TableCell>

                  {/* Last sale */}
                  <TableCell sx={{ color: "#BA7517" }}>
                    {item.days_since_last_sale}d ago
                  </TableCell>

                  {/* Risk */}
                  <TableCell>
                    <Chip
                      label={`~${item.predicted_dead_in_days}d`}
                      size="small"
                      sx={{
                        bgcolor: `${riskColor}15`,
                        color: riskColor,
                        fontWeight: 500,
                      }}
                    />
                  </TableCell>

                  {/* Cash */}
                  <TableCell sx={{ color: "#E24B4A", fontWeight: 500 }}>
                    {currency(item.at_risk_cash)}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
}